import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    // Throwing beats returning a null-ish default: a component rendered outside
    // the provider would otherwise silently read "no permissions" and hide
    // itself, which looks like a permission bug rather than a wiring bug.
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
